import { HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { DrrHttpClient } from '../../../http/drr-http-client'
import {
  INCLUDE_AAA_HEADERS,
  INCLUDE_AUTH_HEADERS,
  USE_BASE_URL,
  WITH_CREDENTIALS,
} from '../../../shared/services/http-context.tokens'
import { ConfigService } from '../../config/config.service'
import { IpRegionSchema } from './ip-locate.model'
import { IpLocateResponse, IpRegion } from './ip-locate.types'

@Injectable({ providedIn: 'root' })
export class IpLocateService {
  constructor(
    private http: DrrHttpClient,
    private configService: ConfigService
  ) {}

  getIpRegion$(): Observable<IpRegion> {
    const { ipInterrogateURL } = this.configService.getConfig()

    return this.http
      .get<IpLocateResponse>(ipInterrogateURL, {
        context: new HttpContext()
          .set(USE_BASE_URL, false)
          .set(WITH_CREDENTIALS, false)
          .set(INCLUDE_AUTH_HEADERS, false)
          .set(INCLUDE_AAA_HEADERS, false),
      })
      .pipe(
        map((response) => this.toIpRegion(response)),
        tap((region) => IpRegionSchema.validateSync(region))
      )
  }

  private toIpRegion(response: IpLocateResponse): IpRegion {
    const ip = response?.services?.geo?.ip

    return {
      city: ip?.city?.trim() || '',
      state: ip?.state?.trim() || '',
      postalCode: ip?.postalCode?.trim() || '',
    }
  }
}
